/**
 * Booking Integration JavaScript
 * This file handles the integration of booking app blocks and Servicify calendar
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize booking integration
  initBookingIntegration();
});

function initBookingIntegration() {
  // Load Servicify calendar if present
  loadServicifyCalendar();
  
  // Load app blocks
  loadAppBlocks();
}

function loadServicifyCalendar() {
  const servicifyContainers = document.querySelectorAll('[data-servicify="inline-calendar"]');
  
  servicifyContainers.forEach(container => {
    console.log('Servicify calendar container found:', container);
    
    // Get dynamic configuration from data attributes
    const productId = container.getAttribute('data-product');
    const variantId = container.getAttribute('data-variant');
    const eventId = container.getAttribute('data-event');
    const bookingType = container.getAttribute('data-booking-type');
    
    console.log('Servicify config:', { productId, variantId, eventId, bookingType });
    
    // Add loading state
    container.innerHTML = '<div class="servicify-loading">Loading calendar...</div>';
    
    // The Servicify script should automatically initialize the calendar
    // If it doesn't, you might need to manually load the Servicify script
    loadServicifyScript();
  });
}

function loadServicifyScript() {
  // Check if Servicify script is already loaded
  if (window.Servicify) {
    return;
  }
  
  // Load Servicify script if not already loaded
  const script = document.createElement('script');
  script.src = 'https://cdn.servicify.com/embed.js';
  script.async = true;
  script.onload = function() {
    console.log('Servicify script loaded');
    // Initialize calendar after script loads
    if (window.Servicify && window.Servicify.init) {
      window.Servicify.init();
    }
  };
  script.onerror = function() {
    console.error('Failed to load Servicify script');
  };
  
  document.head.appendChild(script);
}

function loadAppBlocks() {
  // App blocks removed - only Servicify calendar is used now
  console.log('App blocks removed - only Servicify calendar is active');
}

// Add CSS for loading states
const style = document.createElement('style');
style.textContent = `
  .servicify-loading {
    text-align: center;
    padding: 40px 20px;
    color: #666;
    background: #f8f9fa;
    border-radius: 8px;
    border: 2px dashed #ddd;
  }
  
  .servicify-loading::before {
    content: "⏳ ";
    margin-right: 8px;
  }
`;
document.head.appendChild(style);
